import { Component } from '@angular/core';
import { QaGradingAreaComponent } from '../qa-grading-area/qa-grading-area.component';

@Component({
	selector: 'app-components-qa-grading-area-panel',
	templateUrl: './qa-grading-area-panel.component.html'
})
export class QaGradingAreaPanelComponent extends QaGradingAreaComponent {
}